// Detects phones and tablets by device, not by screen width: unfolded foldables and tablets
// have desktop-sized viewports but still have a camera, so breakpoint checks are not suitable.
export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const uaData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (uaData?.mobile) return true;

  const userAgent = navigator.userAgent || '';
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)) return true;

  // iPadOS Safari reports a desktop (Macintosh) user agent; fall back to touch capability.
  if (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1) return true;

  // Chrome gives large Android tablets a desktop user agent; a coarse primary pointer still means touch.
  return typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: coarse)').matches;
};
